document.querySelector("#si-requiere").addEventListener("click", function mostrarFormulario() {
    document.getElementById("facturacion-true").style.display = "block";
    document.getElementById("notas-facturacion").style.display = "none";
    let notas = document.getElementById("text-factura").textContent;
    document.getElementById("text-factura").textContent = `${notas}. Este pedido SI necesita facturacion a los datos correspondientes del cliente`
})

document.querySelector("#no-requiere").addEventListener("click", function ocultarFormulario() {
    let notas = document.getElementById("text-factura").textContent;
    document.getElementById("text-factura").textContent = `${notas}. Este pedido NO necesita facturacion`
    document.getElementById("facturacion-true").style.display = "none";
})

document.querySelector("#datos-registrados").addEventListener("click", function() {
    document.getElementById("notas-facturacion").style.display = "none";
    document.getElementById("text-factura").textContent = "Este pedido SI necesita facturacion a los datos correspondientes del cliente";
})
document.querySelector("#datos-distintos").addEventListener("click", function() {
    document.getElementById("notas-facturacion").style.display = "block";
    //document.getElementById("text-factura").textContent = guardarInfo();
    //const informacion = guardarInfo();
    //console.log(informacion);
})


function guardarInfo() {
    let fecha = document.getElementById("fechaPromesa--valor").value;
    let razonSocial = document.getElementById("datos-fiscales__nombre").value;
    let rfc = document.getElementById("datos-fiscales__rfc").value;
    let correo = document.getElementById("datos-fiscales__correo").value;
    let regimenFiscal = document.getElementById("datos-fiscales__regimen-fiscal").value;
    let formaPago = document.getElementById("datos-fiscales__formaPago").value;
    let usoCFDI = document.getElementById("datos-fiscales__usoCFDI").value;
    let metodoPago = document.getElementById("datos-fiscales__metodoPago").value;
  
    let datos = `Este pedido necesita factura a los siguientes datos fiscales\nRazon Social: ${razonSocial}\nRFC: ${rfc}\nCorreo: ${correo}\n\nRegimen Fiscal: ${regimenFiscal}\nForma de Pago:${formaPago}\nUso del CDFI:${usoCFDI}\nMetodo de Pago: ${metodoPago}`;
    document.getElementById("text-factura").textContent = datos;
    const mensajeFac = document.getElementById("envair-informacion-factura");
    const alerta = document.createElement("P");
    alerta.textContent ="El formulario fue enviado correctamente";
    mensajeFac.appendChild(alerta);
    alerta.classList.add("correcto")
    setTimeout(() => {
        alerta.remove();
    }, 3000);

    return datos;
} 
document.querySelector("#si-especifico").addEventListener("click", function mostrarFormularioFecha() {
    document.getElementById("fechaPromesa__contenedor").style.display = "block";
})

document.querySelector("#fechaPromesa--input").addEventListener('change', function asignarValor() {
  let inputFecha = document.getElementById("fechaPromesa--input");
  let separadorFecha = inputFecha.value.split("T");
  let notas = document.getElementById("text-factura").textContent;
  document.getElementById("text-factura").textContent = `El cliente especifico el dia de "${separadorFecha[0]}" a la hora de "${separadorFecha[1]}" como fecha de entrega, ${notas}`

})
document.querySelector("#no-especifico").addEventListener("click", function ocultarFormularioFecha() {
    document.getElementById("fechaPromesa__contenedor").style.display = "none";
})



